import React from 'react';
import { Button, FormLabel, Grid } from '@material-ui/core';

import { FormAutoCompleteCombo, FormSelect, FormTextField } from '../../../components';
import { getI18n } from "../../../utils/intl";
import { useIntl } from "react-intl";
import { bool, func, number, string } from "prop-types";
import DateRangePicker from "../../../components/DateRangePicker";

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="request-filter-by-name"
      data-apim-test="request-filter-by-name"
    />
  </Grid>
);

export const FilterByDate = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <DateRangePicker {...props}/>
  </Grid>
);

export const FilterByEmail = (props) => (
  <>
    <Grid item md={"auto"} sm={3} xs={12}>
      <FormSelect
        id="request-filter-by-email-type"
        data-apim-test="request-filter-by-email-type"
        data={props.selectData}
        value={props.selectValue}
        fieldContainerClass={props.selectContainerClass}
        handleChange={props.selectHandleChange}
        name={props.name}
        selectFieldClass={props.selectFieldClass}
        noNoneOption
        noNativeSelect
      />
    </Grid>
    <Grid item md={2} sm={3} xs={12}>
      <FormTextField
        name={props.name}
        fieldContainerClass={props.textFieldContainerClass}
        textFieldClass={props.textFieldClass}
        handleChange={props.textFieldHandleChange}
        onKeyPress={props.textFieldKeyPress}
        value={props.textFieldValue}
        id="request-filter-by-email"
        data-apim-test="request-filter-by-email"
        hideLabel={true}
        placeholder={props.textFieldPlaceholder}
      />
    </Grid>
  </>
);
FilterByEmail.propTypes = {
  selectData: [],
  selectValue: string,
  selectContainerClass : {},
  selectHandleChange : func,
  name : func,
  selectFieldClass : {},
  textFieldContainerClass : {},
  textFieldClass : {},
  textFieldHandleChange : func,
  textFieldKeyPress : func,
  textFieldValue : string,
  textFieldPlaceholder : string,
};


export const FilterByType = (props) => (
  <Grid item md={2} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="request-filter-by-type"
      data-apim-test="request-filter-by-type"
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterByOrg = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormAutoCompleteCombo
      {...props}
      id="request-filter-by-org"
      data-apim-test="request-filter-by-org"
    />
  </Grid>
);

export const HeaderActionButtons = (props) => {
  const {
    classes = {},
    bulkActionsItemsCount,
    onBulkAccept,
    onBulkAcceptDisabled,
    onBulkReject,
    onBulkRejectDisabled,
  } = props;

  const id = 'request-assignment'
  const intl = getI18n(useIntl());
  return (
    <div className={classes.actionsFieldContainer}>
      <FormLabel className={ classes.actionsLabel }>
        {intl.getI18nMessage('label.request.details.actions.count', { count: bulkActionsItemsCount })}
      </FormLabel>
      <Grid
        item md={12} sm={12} xs={12}
        className={classes.headerButtons}
      >
        <Button
          variant="contained" color="secondary"
          className={classes.bulkActionAcceptButton}
          id={`${id}-accept`} data-apim-test={`${id}-accept`} data-layer7-test={`${id}-accept`}
          onClick={onBulkAccept}
          disabled={onBulkAcceptDisabled}
        >
          {intl.getI18nMessage('label.request.list.actions.accept')}
        </Button>
        <Button
          variant="contained" color="secondary"
          className={classes.bulkActionRejectButton}
          id={`${id}-reject`} data-apim-test={`${id}-reject`} data-layer7-test={`${id}-reject`}
          onClick={onBulkReject}
          disabled={onBulkRejectDisabled}
        >
          {intl.getI18nMessage('label.request.list.actions.reject')}
        </Button>
      </Grid>
    </div>
  );
}

HeaderActionButtons.propTypes = {
  classes: {},
  bulkActionsItemsCount: number,
  onBulkAccept : func,
  onBulkAcceptDisabled : bool,
  onBulkReject : func,
  onBulkRejectDisabled : bool,
};
